import { html, mount } from '../core/html.js';
import { post, session, refreshMe, hasRole } from '../core/api.js';
import { withBusy, toast } from '../core/ui.js';
import { pct, rm } from '../core/format.js';
import { t } from '../core/i18n.js';
import { navigate } from '../app.js';

export async function render(main) {
  if (hasRole('HOST')) { navigate('/host', { replace: true }); return; }
  const s = session.config.settings;
  const fee = Math.round((50000 * s.platform_fee_bps) / 10000);
  mount(main, html`<div class="wrap" style="max-width:720px;padding-top:24px">
    <h1>${t('becomehost.title', { name: s.platform_name })}</h1>
    <p class="muted">${t('becomehost.same_account')}</p>
    <div class="panel soft"><h2>${t('becomehost.how_title')}</h2>
      <ol style="padding-left:20px;margin:0">
        <li>${t('becomehost.step1', { total: rm(50000) })}</li>
        <li>${t('becomehost.step2', { rate: pct(s.platform_fee_bps), fee: rm(fee), net: rm(50000 - fee) })}</li>
        <li>${t('becomehost.step3')}</li>
        <li>${t('becomehost.step4', { min: rm(s.minimum_withdrawal_minor) })}</li>
      </ol></div>
    <form id="hf" class="panel stack" style="margin-top:16px"><h2>${t('becomehost.profile_title')}</h2>
      <label class="field"><span>${t('becomehost.display_name')}</span><input class="input" name="display_name" required minlength="2" maxlength="60"></label>
      <label class="field"><span>${t('becomehost.phone')}</span><input class="input" name="phone" type="tel" required value="${session.me.phone || ''}"></label>
      <label class="field"><span>${t('becomehost.bio')}</span><textarea class="input" name="bio" maxlength="1000"></textarea></label>
      <button class="btn btn-primary">${t('becomehost.submit')}</button>
      <p class="small muted">${t('becomehost.next_steps')}</p></form></div>`);
  main.querySelector('#hf').onsubmit = (e) => {
    e.preventDefault();
    const f = Object.fromEntries(new FormData(e.target).entries());
    withBusy(e.submitter, async () => {
      await post('/api/host/become', { display_name: f.display_name, phone: f.phone, bio: f.bio || undefined });
      await refreshMe();
      toast(t('becomehost.done'));
      navigate('/host/settings');
    });
  };
}
